import { render, staticRenderFns } from "./addPassenger.vue?vue&type=template&id=46cc947b&"
import script from "./addPassenger.vue?vue&type=script&lang=js&"
export * from "./addPassenger.vue?vue&type=script&lang=js&"
import style0 from "./addPassenger.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports